import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/vercel/path0/website/src/components/layout/Layout.tsx");
